import React from 'react';
import {translate} from 'sulu-admin-bundle/utils/Translator';

export default (props) => {

	const {dataPath, data, schemaOptions: parameters} = props;

	const clrInputsCSS = { 
		display : 'flex',
		flexDirection: 'row',
    	gap: '20px'
	}

	const name = data[dataPath.replace(/\//g, "")];
	
	const labelTitle = translate(parameters?.labelTitle?.value || name || '');
	const labelPrefix = translate(parameters?.prefix?.value || '');
	const labelSufix = translate(parameters?.sufix?.value || '');
	const size = parameters?.size?.value || 1;
	const align = parameters?.align?.value || '';

	const headings = ['p','h1', 'h2', 'h3', 'h4', 'h5', 'h6'];


	const titleWTag = () =>  (`<${headings[size - 1]} style="text-align: ${ align }">${labelPrefix} ${labelTitle} ${labelSufix} </${headings[size - 1]}>`);

	
	return (
			<div className="custom-label__dhb">
				<div dangerouslySetInnerHTML={{__html: titleWTag()}}></div>
			</div>
		);
}